module.exports = __webpack_public_path__ + "static/media/permissions.e1843faf.svg";